import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from '../finance/shared';

const FinancialGoalCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [goal, setGoal] = useState('100.000,00');
  const [initial, setInitial] = useState('10.000,00');
  const [monthly, setMonthly] = useState('1.000,00');
  const [rate, setRate] = useState('10,00');
  const [res, setRes] = useState<any>(null);

  const calculate = () => {
    const target = parseFloat(parseBrazilianNumber(goal)) || 0;
    const start = parseFloat(parseBrazilianNumber(initial)) || 0;
    const monthlyAport = parseFloat(parseBrazilianNumber(monthly)) || 0;
    const annualRate = parseFloat(parseBrazilianNumber(rate)) / 100;
    const monthlyRate = Math.pow(1 + annualRate, 1 / 12) - 1;

    if (target <= start || monthlyAport <= 0) return;

    let balance = start;
    let months = 0;
    while (balance < target && months < 600) {
      months++;
      balance = balance * (1 + monthlyRate) + monthlyAport;
    }

    setRes({ months, years: (months / 12).toFixed(1) });
    onResultChange([
      { label: 'Tempo', value: `${months} meses (${(months / 12).toFixed(1)} anos)` },
      { label: 'Aporte Mensal', value: `R$ ${monthlyAport.toLocaleString('pt-BR')}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl border border-theme-border shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <FormField label="Meta (R$)" value={goal} onChange={setGoal} isNumeric required type="text" />
          <FormField label="Início (R$)" value={initial} onChange={setInitial} isNumeric required type="text" />
          <FormField label="Mensal (R$)" value={monthly} onChange={setMonthly} isNumeric required type="text" />
          <FormField label="Taxa Anual (%)" value={rate} onChange={setRate} isNumeric required type="text" />
        </div>
        <div className="flex justify-center">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:scale-105 transition-all">Simular Meta</button>
        </div>
        {res && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            <ResultCard title="Meses" value={res.months} color="indigo" />
            <ResultCard title="Anos" value={res.years} color="purple" />
          </div>
        )}
      </div>
    </div>
  );
};

export default FinancialGoalCalculator;
